module.exports = __webpack_public_path__ + "img/mantenimiento.7f6e026a.png";